export default {
  list: state => state.serviceList,
  serviceListWithSearch: state => name => {
    if(state.serviceList && state.serviceList.items) {
      if(name != '') {
          let search_arr = [];
          for(let i = 0; i < state.serviceList.items.length; i++) {
              let cate = state.serviceList.items[i];
              let service_temp = [];
              for(let j = 0; j < cate.services.length; j++) {
                  if(cate.services[j].name.toLowerCase().includes(name.toLowerCase())) {
                      service_temp.push(cate.services[j]);
                  }
              }
              search_arr.push({id: cate.id, name: cate.name, services: service_temp, color_detail: cate.color_detail});
          }
          return search_arr;
      } else {
          return state.serviceList.items;
      }
    } else {
      return [];
    }
  },
}
